
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.9 8.9l-1.7 1-4-6.9 1.7-1 4 6.9m-12.1-1l3 5.2 6.1-3.5-3-5.2-6.1 3.5m1.6 4.8l-2-3.5-4.3 2.5 2 3.5 4.3-2.5m-9.3 1.9l1 1.7 2.6-1.5-1-1.7-2.6 1.5m10-.6l-.3-.4-4.3 2.5.3.4c.2.3.5.6.8.8L7 22h2l1.4-4.3h.1L12 22h2l-1.9-5.6c.5-.7.5-1.6 0-2.4z"}})])
          )
        }
      }
    